import { ReactElement, useEffect } from 'react';
import { UIFilterGroup, useUINav } from '@/ui';
import {
    DashboardMap,
    DeviceFilterItem,
    MiniTasksList,
    NoAccessMask,
    TeamFilterItem,
    UserFilterItem,
    LiveTasksIndicator
} from '@/tasks/components';
import { useTaskDashboard } from '@/tasks/providers';
import { useCompanyPermissions } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';

const ITEM_SPACING = 16;

export function DashboardPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { locations, tasks, loading } = useTaskDashboard();

    const { setParts } = useUINav();
    useEffect(() => {
        setParts([{ text: t('shared.labels.live_dashboard') }]);
    }, [setParts, t]);

    const { hasSubscription, hasLicense } = useCompanyPermissions();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                flex: 1,
                gap: ITEM_SPACING,
                paddingLeft: 32,
                paddingTop: ITEM_SPACING,
                paddingRight: 32,
                paddingBottom: ITEM_SPACING
            }}
        >
            <div style={{ display: 'flex', flexShrink: 1 }}>
                <UIFilterGroup>
                    <TeamFilterItem />
                    <UserFilterItem />
                    <DeviceFilterItem />
                </UIFilterGroup>
            </div>
            <div
                style={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'row',
                    gap: ITEM_SPACING
                }}
            >
                <div style={{ display: 'flex', flex: 2 }}>
                    <DashboardMap users={locations} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        gap: ITEM_SPACING
                    }}
                >
                    <LiveTasksIndicator />
                    <MiniTasksList tasks={tasks} loading={loading} />
                </div>
            </div>

            {!hasSubscription && <NoAccessMask withMessage="no-subscription" />}
            {hasSubscription && !hasLicense && (
                <NoAccessMask withMessage="no-license" />
            )}
        </div>
    );
}
